import api from "@/utils/axios";

/**
 * Documents API
 */

/**
 * GET all documents
 * Optional filters: group_id, status
 */
export const getAllDocuments = (params = {}) =>
    api.get("/api/documents", { params });

/**
 * GET documents by document group ID
 * Supports optional query params: status, page, limit
 */
export const getDocumentsByGroupId = (groupId, params = {}) =>
    api.get(`/api/documents/group/${groupId}`, { params });

/**
 * GET document by ID
 */
export const getDocumentById = (id) =>
    api.get(`/api/documents/${id}`);

/**
 * CREATE new document(s)
 * Accepts FormData for multiple files
 * Payload should include:
 * - section_id (required)
 * - files[] (required)
 * - filenames[] (required)
 * - descriptions[] (optional)
 */
export const createDocument = (payload) => {
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    return api.post("/api/documents", payload, config);
};

/**
 * UPDATE a document by ID
 * Accepts metadata + optional file replacement
 * If updating file, use FormData with field "file"
 */
export const updateDocument = (id, payload) => {
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    return api.put(`/api/documents/${id}`, payload, config);
};

/**
 * DELETE a document by ID
 * Hard delete
 */
export const deleteDocument = (id) =>
    api.delete(`/api/documents/${id}`);

/**
 * DOWNLOAD a document by ID
 * filename is optional; defaults to document's original name
 */
export const downloadDocument = async (id, filename) => {
    const response = await api.get(`/api/documents/download/${id}`, {
        responseType: "blob",
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", filename || "document");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
};